<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kullanıcı</label>
            <v-select-list :options="users" v-model="user" placeholder="Kullanıcı" v-on:input="getTypes" label="FullName"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Rapor Türü</label>
            <v-select-list :options="types" v-model="type" multiple placeholder="Rapor Türü" :loading="typesLoading" :disabled="!value.UserId || (types || []).length == 0 || typesLoading" label="Name"></v-select-list>
        </div>
    </div>
</template>

<script>
import { UserApi } from '@/api/user'
import { ReportApi } from '@/api/report'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            users:[],
            types:[],
            typesLoading:false
        }
    },
    mounted(){
        this.getUsers()
        this.getTypes()
    },
    methods:{
        getUsers(){
            UserApi.List().then(res=>{
                this.users = res.data.Data
            })
        },
        getTypes(){
            if(this.value.UserId){
                this.typesLoading = true
                this.value.ReportTypes = []
                this.types = []
                ReportApi.Type(this.value.UserId).then(res=>{
                    this.typesLoading = false
                    this.types = res.data.Data
                    this.value.ReportTypes = (this.types || []).filter(t=>t.IsSelected).map(t=>t.Value)
                })
            }
        }
    },
    computed:{
        user:{
            get:function(){
                return this.users.find(r=>r.Id == this.value.UserId)
            },
            set:function(value){
                this.value.UserId = value?.Id || null
            }
        },
        type:{
            get:function(){
                return this.types.filter(v=>this.value.ReportTypes.includes(v.Value))
            },
            set:function(value){
                this.value.ReportTypes = value?.map(v=>v.Value) || []
            }
        }
    }
}
</script>

<style>

</style>